// routes/generator.chat-editing._index.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/generator.chat-editing._index')

export const handle = {
  name: 'generator/chat-editing',
  track: { scene: 'chat-editing', section: 'preview' },
}

export default dynamic(getClientModule, { ssr: false })
